module.exports = __webpack_public_path__ + "assets/minus.641106ae.svg";